import { HTTP_METHODS } from '@studio/constants/axios';
import { CENTRAL_API_V3 } from '@studio/constants/env-variables';
import type { GoLive } from '@studio/types';

export const root = {
  [HTTP_METHODS.POST]: {
    url: `${CENTRAL_API_V3}/customers/@customerId/golive`,
    request: {} as GoLive.Post.GoLive,
    response: {} as GoLive.Post.GoLiveResponse,
    method: HTTP_METHODS.POST,
  },
};
